import { useCallback, useEffect, useState } from "react";

const KEY = "mc_recently_viewed";
const MAX = 8;

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
}

function write(ids) {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids.slice(0, MAX)));
  } catch {
    /* quota / private mode — ignore */
  }
}

/**
 * Tracks recently viewed vehicle IDs in localStorage.
 * - track(id): moves id to front (most recent), caps at MAX=8
 * - ids: current ordered list (newest first)
 */
export default function useRecentlyViewed() {
  const [ids, setIds] = useState(() => read());

  // sync across tabs
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setIds(read());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const track = useCallback((id) => {
    if (!id) return;
    setIds((prev) => {
      const next = [id, ...prev.filter((x) => x !== id)].slice(0, MAX);
      write(next);
      return next;
    });
  }, []);

  return { ids, track };
}
